import { render } from "./OrderTermsModal.vue?vue&type=template&id=725dfcee"
import script from "./OrderTermsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderTermsModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/parts/modal/OrderTermsModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "725dfcee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('725dfcee', __exports__)) {
    console.log('reload')
    api.reload('725dfcee', __exports__)
  }
  
  module.hot.accept("./OrderTermsModal.vue?vue&type=template&id=725dfcee", () => {
    console.log('re-render')
    api.rerender('725dfcee', render)
  })

}


export default __exports__